:host {
  display: block;
}

sc-form {
  width: 100%;
}

.selected-price {
  display: flex;
  align-items: center;
  gap: var(--sc-spacing-small);
  flex-wrap: wrap;

  &__wrap {
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    gap: var(--sc-spacing-xx-small);
    color: var(--sc-selected-price-color, var(--sc-color-gray-800));
    line-height: 1;
  }

  &__price {
    font-size: var(--sc-font-size-xxx-large);
    font-weight: var(--sc-font-weight-bold);
    white-space: nowrap;
  }

  &__interval {
    font-weight: var(--sc-font-weight-bold);
    opacity: 0.65;
    white-space: nowrap;
  }

  &__scratch-price {
    opacity: 0.65;
    font-weight: var(--sc-font-weight-normal);
    text-decoration: line-through;
  }
}
